export function deletar(fetch, id) {
  return fetch().delete("/caracteristica/" + id);
}

export function getAll(fetch, filtro) {
  return fetch().get("/caracteristica?filtro=" + filtro);
}

export function getDetalhe(fetch, id) {
  return fetch().get("/caracteristica/" + id);
}

export function put(fetch, loja) {
  return fetch().put("/caracteristica", loja);
}
export function post(fetch, loja) {
  return fetch().post("/caracteristica", loja);
}
